module.exports = __webpack_public_path__ + "static/images/components/NavigationArrow/images/arrow-left-normal-tiny.902b222b.png";


//////////////////
// WEBPACK FOOTER
// ./components/NavigationArrow/images/arrow-left-normal-tiny.png
// module id = 2643
// module chunks = 11